import { Col, Flex, Row, Tabs, TabsProps } from "antd";
import ServiceTable from "../../components/catalog/ServiceTable";
import ProductTable from "../../components/catalog/ProductTable";
import GiftCardTable from "../../components/catalog/GiftCardTable";
import MembershipTable from "../../components/catalog/MembershipTable";
import QuickActionButton from "../../components/common/QuickActionButton";
import SalonLocationsSelect from "../../components/common/SalonLocationsSelect";
import { useLocation, useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import PackagesTable from "../../components/catalog/PackagesTable";

export default function CatalogTable() {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const defaultTab = queryParams.get("tab") || "1";

  const itemsTab: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div
          className={"min-w-[100px] justify-center flex items-center gap-2 "}
        >
          {intl.formatMessage({ id: "services_tab_label" })}
        </div>
      ),
      children: <ServiceTable />,
    },
    {
      key: "2",
      label: (
        <div
          className={"min-w-[100px] justify-center flex items-center gap-2 "}
        >
          {intl.formatMessage({ id: "packages_tab_label" })}
        </div>
      ),
      children: <PackagesTable />,
    },
    {
      key: "3",
      label: (
        <div
          className={"min-w-[100px] justify-center flex items-center gap-2 "}
        >
          {intl.formatMessage({ id: "products_tab_label" })}
        </div>
      ),
      children: <ProductTable />,
    },
    {
      key: "4",
      label: (
        <div
          className={"min-w-[100px] justify-center flex items-center gap-2 "}
        >
          {intl.formatMessage({ id: "gift_cards_tab_label" })}
        </div>
      ),
      children: <GiftCardTable />,
    },
    {
      key: "5",
      label: (
        <div
          className={"min-w-[100px] justify-center flex items-center gap-2 "}
        >
          {intl.formatMessage({ id: "memberships_tab_label" })}
        </div>
      ),
      children: <MembershipTable />,
    },
  ];
  const onChange = (key: string) => {
    console.log(key);
    navigate(`?tab=${key}`);
  };

  return (
    <div className="mt-5 p-2 md:p-7 space-y-8">
      <Flex className="justify-start items-start" vertical>
        <Row className="w-full flex items-center justify-between">
          <Col className="text-color-primary text-2xl font-semibold leading-7">
            <FormattedMessage id="catalog_title" />
          </Col>
          <QuickActionButton />
        </Row>
        <div className="my-4 text-color-gray text-base font-normal leading-7">
          <FormattedMessage id="catalog_description" />
        </div>
        <SalonLocationsSelect />
      </Flex>
      <div className="  tabs-card-wrapper  ">
        <Tabs
          activeKey={defaultTab}
          onChange={onChange}
          items={itemsTab}
          className=""
          type="card"
        />
      </div>
    </div>
  );
}
